import React from "react";

import { selectProjectId } from "@editor/reducers/core-reducer";
import { useEditorSelector } from "@editor/store";
import { trpcClient } from "@editor/utils/trpc";

import { z } from "zod";

const requestProductMessageSchema = z.object({
  type: z.literal("requestProduct"),
  payload: z.object({
    productId: z.string(),
  }),
});

const returnProductMessageSchema = z.object({
  type: z.literal("returnProduct"),
  payload: z.object({
    product: z.any(),
  }),
});
type ReturnProductMessage = z.infer<typeof returnProductMessageSchema>;

export const useIframeMessaging = () => {
  const projectId = useEditorSelector(selectProjectId);

  React.useEffect(() => {
    if (!projectId) {
      return;
    }
    const handleMessageAsync = async (event: MessageEvent) => {
      if (!event.source || !event.origin) {
        return;
      }
      const messageResult = requestProductMessageSchema.safeParse(event.data);
      if (!messageResult.success) {
        return;
      }
      const message = messageResult.data;
      // TODO: use the query cache
      const product = await trpcClient.product.get.query({
        projectId,
        externalId: message.payload.productId,
      });
      const returnMessage: ReturnProductMessage = {
        type: "returnProduct",
        payload: {
          product: product,
        },
      };
      event.source.postMessage(returnMessage, { targetOrigin: event.origin });
    };
    const handleMessage = (event: MessageEvent) => {
      void handleMessageAsync(event);
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [projectId]);
};
